import { render, staticRenderFns } from "./cModalMotivo.vue?vue&type=template&id=445fe635"
import script from "./cModalMotivo.vue?vue&type=script&lang=js"
export * from "./cModalMotivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports